import { render, staticRenderFns } from "./WorksDetail.vue?vue&type=template&id=1842947c&"
import script from "./WorksDetail.vue?vue&type=script&lang=ts&"
export * from "./WorksDetail.vue?vue&type=script&lang=ts&"
import style0 from "./WorksDetail.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports